module.exports = __webpack_public_path__ + "media/images/webpage/shared/about/about-284f43081fa6e345a87b3686f2e15702.webp";